import config from "../../src/common/default_config";
import { EEnabledFeatures } from "../../src/common/utilities/enums";

const homeRedirectionLinkUAT = "https://ua2-sfogliatore.gazzetta.it/";
const homeRedirectionLinkPROD = "https://sfogliatore.gazzetta.it/";
const homeRedirectionLink =
  process.env.ENV === "uat" || process.env.ENV === "dev"
    ? homeRedirectionLinkUAT
    : homeRedirectionLinkPROD;

export default class options extends config {
  // Kiosk settings
  static homeRedirectionLink = homeRedirectionLink;
  static useSliderForPromospot = true;
  static useSliderForHorsSeries = true;
  static useSliderForArchive = true;
  static showPreviewPublications = true;

  // pdf options
  static page_ratio = 1.4745;
  static page_width_reference = 100000;
  static page_height_reference = 100000;
  static usePdfDesktop = true;
  static usePdfPhoneNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfPhone = true;
  static usePdfTabletNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfTablet = true;

  // Reader settings
  static replicaReadingModeToggle = {
    phone: false,
    tablet: true,
    desktop: true,
  };

  // Social sharing settings
  static sharingOptions = {
    Facebook: true,
    WhatsApp: true,
    TwitterX: true,
    Mail: true,
    MailSubject: null,
    MailSubjectIntro: "Article shared - ",
  };
  static socialSharingHash = "social";
  static shareFromReader = true;

  // Print and download settings
  static featuresToBeEnabledByBE = [
    EEnabledFeatures.PRINT,
    EEnabledFeatures.DOWNLOAD_PDF,
  ];
  static printArticle = false;

  // SSO
  static SSOEnabled = true;
  static paywallRedirectionUrl = true;
  static externalPaywallMaxRedirectionNumber = 5;
  static deleteSSOCookie = false;
  static urlRedirectParameter = "redirectionUrl";
  static getSSOTokenFromUrl = false;
  static SSOCookieName = "rcsDomainSession"; // Very important: if this value is changed, also change it in the `headPartial.ejs`
  static SSOCookieOptions = {
    path: "",
    domain: ".gazzetta.it",
  };
}



// WEBPACK FOOTER //
// ./clients/rcs-gds/config.js